import {diff} from 'deep-diff'
import Immutable from 'immutable'

// Get difference between object, where b is the old object and a is a superset of b
export function getObjectDifference(a, b) {
  let differences = diff(a, b);
  let object = Immutable.Map();
  if (differences) {
    for (let d of differences) {
      object = object.setIn(d.path, d.lhs)
    }

  }
  return object.toJS();
}



// WEBPACK FOOTER //
// ./src/helpers/getObjectDifference.js